/**
 * Merchant-facing Redo product groupings used by the integrations catalog and
 * status RPCs. Coarser than billing's RedoInternalProduct by design.
 */
export const RedoProduct = {
  CONVERSION: "conversion",
  COVERAGE: "coverage",
  CUSTOMER_ACCOUNTS: "customer-accounts",
  MARKETING: "marketing",
  OMS: "oms",
  ORDER_TRACKING: "order-tracking",
  /** Platform-managed integrations with no merchant-facing product grouping.
   * Shown only to Redo admins in the catalog UI. */
  PLATFORM: "platform",
  /** Disputes/chargebacks. Merchant-facing at /finance/disputes. */
  RECLAIM: "reclaim",
  RETURNS: "returns",
  SUPPORT: "support",
} as const;
export type RedoProduct = (typeof RedoProduct)[keyof typeof RedoProduct];

export const PRODUCT_LABELS: Record<RedoProduct, string> = {
  [RedoProduct.PLATFORM]: "Platform",
  [RedoProduct.CONVERSION]: "Conversion",
  [RedoProduct.COVERAGE]: "Coverage",
  [RedoProduct.CUSTOMER_ACCOUNTS]: "Customer accounts",
  [RedoProduct.MARKETING]: "Marketing",
  [RedoProduct.OMS]: "Order management",
  [RedoProduct.ORDER_TRACKING]: "Order tracking",
  [RedoProduct.RECLAIM]: "Reclaim",
  [RedoProduct.RETURNS]: "Returns",
  [RedoProduct.SUPPORT]: "Support",
};
